@if (label()) {
  <label for="inputIcon" class="col-span-12 mb-1 text-sm font-medium">
    {{ label() }}
  </label>
}

<p-iconfield class="inline col-span-12">
  @if (position() === 'left') {
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
  }

  <input
    placeholder="Normal"
    pInputText
    pSize="small"
    id="inputIcon"
    [placeholder]="placeholder()"
    [value]="value"
    (input)="onInput($event)"
    (blur)="onBlur()"
    [disabled]="isDisabled()"
    [ngClass]="{ 'ng-invalid': showErrors, 'ng-dirty': showErrors }"
    class="w-full"
    (click)="$event.stopPropagation()"
  />

  @if (position() === 'right') {
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
  }
</p-iconfield>

<app-helper-text
  class="col-span-12"
  [errorMessage]="errorMessage"
  [showErrors]="showErrors"
  [helperText]="helperText()"
/>

<ng-template #iconTemplate>
  <p-inputicon class="material-symbols-outlined top-[35%] mr-1">
    {{ icon() }}
  </p-inputicon>
</ng-template>
